import config from "config";
import Form from "../Form/Form";
import useCustomLoginErrorHandler from "hooks/useCustomLoginErrorHandler";
import ApiRequest from "utils/ApiRequest/apiRequest.js";

import { useToasts } from "react-toast-notifications";
import { useContent } from "contexts/contentContext/contentContext";
import { useMail } from "contexts/mailContext/mailContext";
import { useModal } from "contexts/modalContext/modalContext";
import { useUser } from "contexts/userContext/userContext";
import { loginFields } from "../../Structure/Login/LoginFields";

import { memo, useRef, useState } from "react";

interface LoginFormI {
  email?: string;
  callback?: (...args: any[]) => void;
  addSubUserToOrganization?: (...args: any[]) => void;
  completeAddSubUser?: (...args: any[]) => void;
  asRootUser?: boolean;
}

const LoginForm = memo((props: LoginFormI) => {
  const {
    email,
    callback,
    addSubUserToOrganization,
    completeAddSubUser,
    asRootUser,
  } = props;

  const { closeModal } = useModal();
  const { getTextByKey, getCurrentPage, getPath } = useContent();
  const { getMailId, setMetaDataProp } = useMail();
  const { login } = useUser();
  const { addToast } = useToasts();
  const [emailField, setEmailField] = useState(email || "");

  const externalRecaptchaRef = useRef(null);

  const handleCallRecaptcha = async () => {
    if (config.env.type === "dev") return "";

    const token = await externalRecaptchaRef.current.execute();
    return token;
  };

  const handleCustomError = useCustomLoginErrorHandler();

  const handleSubmit = async (body) => {
    setEmailField(body.UserName);

    const response = await login(body, handleCallRecaptcha);

    if (response.status === "success") {
      addToast(getTextByKey("sign-in-success"), {
        appearance: response.status,
      });
      closeModal();
      if (callback !== null) {
        callback(response.message);
      }

      if (getCurrentPage() === "registration" || getCurrentPage() === "login") {
        window.location.href = config.baseurl + getPath() + "home";
      }

      if (getCurrentPage() === "reset-password") {
        window.location.pathname = getPath() + "home";
      }

      if (getCurrentPage() === "gallery") {
        const mailId = getMailId();

        const res = await ApiRequest(
          "Mails",
          "ReactIsMailSavedByUser",
          { mailId },
          "POST"
        );
        if (res.status === "success") {
          setMetaDataProp("IsSavedByUser", res.data);
        }
      }

      if (addSubUserToOrganization) {
        await addSubUserToOrganization(body.UserName);
      }

      if (completeAddSubUser) {
        await completeAddSubUser(body.UserName);
      }
    } else {
      handleCustomError(response.message);
    }

    return response;
  };

  return (
    <Form
      //@ts-ignore
      fieldsProps={{ label: "hidden", field: "square" }}
      fields={loginFields}
      onSubmit={handleSubmit}
      submitProps={{
        title: getTextByKey(asRootUser ? "login" : "login-to-jumbomail"),
        className: "login-submit-button",
      }}
      defaultValuesObj={{ UserName: emailField || "" }}
      buttonProps={{ buttonsSize: "large" }}
      exteranlRecaptchaRef={externalRecaptchaRef}
    />
  );
});

export default LoginForm;
